import React, { useEffect, useState } from "react";
import { logos } from "../../../Utils/logosConfig";
import logoFull from "./../../../assets/img/KonfhubLogos/logo-brown.svg";
import logoFullWhite from "../../../assets/pages/Section/ManageEvents/KonfhubWhiteLogo.svg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const AnimatedLogo = ({ color = "purple" }) => {
    const [lottieFile, setLottieFile] = useState(null);

    const getLottieForToday = () => {
        const today = new Date();
        for (const logo of logos) {
            const startDate = new Date(logo.startDate);
            const endDate = new Date(logo.endDate);
            if (today >= startDate && today <= endDate && logo.color === color) {
                return logo.lottieFile;
            }
        }
        return null;
    };

    useEffect(() => {
        const currentLottie = getLottieForToday();
        if (currentLottie) {
            setLottieFile(currentLottie);
        }
    }, [color]);

    return (
        <div style={{ width: "190px", height: "auto" }}>
            {lottieFile ? (
                <DotLottieReact
                    src={lottieFile}
                    loop
                    autoplay
                />
            ) : (
                <img
                    src={color === "purple" ? logoFull : logoFullWhite}
                    alt="Default Logo"
                    style={{ width: "100%", height: "auto" }}
                />
            )}
        </div>
    );
};

export default AnimatedLogo;
